import { $ } from '@utils';
import MicroModal from 'micromodal';
import ButtonHover from '@utils/ButtonHover';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-modal]')) return;

  MicroModal.init({
    onShow: (modal, trigger, event) => {
      document.body.classList.add('au-overflow-hidden');

      if (modal.querySelector('[data-au-button-hover]')) {
        ButtonHover.init();
      }

      if (event.target.hasAttribute('data-modal-video')) {
        playVideo(modal, event.target);
      }
    },
    onClose: (modal, trigger, event) => {
      document.body.classList.remove('au-overflow-hidden');

      if (event) {
        event.preventDefault();
      }

      if (modal.querySelector('iframe')) {
        stopVideo(modal);
      }

      onCloseModal(modal);
    },
  });

  if (!$('[data-au-modal-onload]')) return;
  initModalOnLoad();
}

/**
 * initModalOnLoad is used to show modal when page loads,
 * without any interaction of user
 *
 * To set it, modal must have a data-au-modal-onload="{{id}}" and a
 * data-au-modal-timing={{Number}}
 *
 */
function initModalOnLoad() {
  const modal_id = $('[data-au-modal-onload]').dataset.auModalOnload;
  let timing = $('[data-au-modal-onload]').dataset.auModalTiming;

  if (timing === 'undefined') {
    timing = 0;
  }

  setTimeout(() => {
    MicroModal.show(modal_id, {
      disableFocus: true,
      onShow: () => {
        document.body.classList.add('au-overflow-hidden');
        ButtonHover.init();
      },
      onClose: (e) => {
        document.body.classList.remove('au-overflow-hidden');
        onCloseModal(e);
      },
    });
  }, Number(timing));
}

function playVideo(modal, trigger) {
  let src = trigger.dataset.modalVideo;

  if (document.cookie.indexOf('__cppr_yt=true') === -1) {
    src = src.replace('youtube.com', 'youtube-nocookie.com');
  }

  modal.querySelector('iframe').setAttribute('src', `${src}?rel=0&autoplay=1`);
}

function stopVideo(modal) {
  modal.querySelector('iframe').setAttribute('src', '');
}

function onCloseModal(e) {
  const modalId = e.id;
  const modalTriggerSection = $(`[data-micromodal-trigger=${modalId}]`)
    ? $(`[data-micromodal-trigger=${modalId}]`).closest('section')
    : undefined;
  let title;

  if (modalTriggerSection) {
    title =
      modalTriggerSection.querySelector('.au-active [data-au-title], .swiper-slide-active [data-au-title]') ||
      modalTriggerSection.querySelector('[data-au-title]') ||
      modalTriggerSection.querySelector('[data-au-heading-title]');
  } else {
    title = e.querySelector('[data-au-title]'); // modal title
  }

  let titleText = title ? title.innerText : '';
  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;

  const clickText = 'cerrar',
    item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'clickBoton',
    item_id,
  });
}

export default { init };
